/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import AppState from './state/AppState';
import ExtJS from './ExtJS';

/**
 * Races app.js's state-seed assignment against ExtJS's own boot, and calls render at most once — whichever finishes
 * first. If the seed arrives and turns the Nexus One state machine on, render immediately; otherwise wait for ExtJS
 * to finish booting as before.
 * @param {function()} render
 */
export function waitForAppStateAvailable(render) {
  let rendered = false;
  const renderOnce = () => {
    if (!rendered) {
      rendered = true;
      render();
    }
  };

  AppState.waitForStateSeed((seed) => {
    if (AppState.startAppState(seed)) {
      renderOnce();
    }
  });
  ExtJS.waitForExtJs(() => {
    // ExtJS still signs users out on its own (menu, idle timeout); the machine has to see that (NEXUS-55433)
    AppState.followExtJsUser();
    renderOnce();
  });
}
